import { Box, Card, Typography } from '@mui/material';
import { FC } from 'react';
import { useMainCardStyles } from './useMainCardStyles';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SplitIcon from '@mui/icons-material/ViewAgendaOutlined';
import CleaningIcon from '@mui/icons-material/LocalCarWashOutlined';
import CheckInIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import LocalGasStation from '@mui/icons-material/LocalGasStation';
import Group from '@mui/icons-material/Group';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

import {
  AccessTime,
  CheckCircleOutline,
  MoreHorizOutlined,
  PeopleOutlined,
  Title,
  PersonAdd,
} from '@mui/icons-material';
import { InfoCard, InfoCardContent } from '../InfoCard/InfoCard';
import { IconType } from '../../enums/IconType';

type Props = {
  icon: IconType;
  primary1: string;
  primary2: string;
  secondary1: string;
  secondary2: string;
  comment?: string;
  tripIsEu?: boolean;
};

export const MainCardContent: FC<Props> = ({
  icon,
  primary1,
  primary2,
  secondary1,
  secondary2,
  comment,
  tripIsEu,
}) => {
  const classes = useMainCardStyles();
  return (
    <>
       <Box sx={classes.heading} px={2} py={1}>
        <Box textAlign="center" mr={3}>
       
          {icon === IconType.Bus && (
            <Box sx={classes.col}>
              <DirectionsBusIcon fontSize="large" />
            </Box>
          )}
          {icon === IconType.Check && <CheckCircleOutline fontSize="large" />}
          {icon === IconType.CheckIn && <CheckInIcon fontSize="large" />}
          {icon === IconType.Cleaning && <CleaningIcon fontSize="large" />}
          {icon === IconType.Coffee && <FreeBreakfastIcon fontSize="large" />}
          {icon === IconType.Food && <RestaurantIcon fontSize="large" />}
          {icon === IconType.Other && <MoreHorizOutlined fontSize="large" />}
          {icon === IconType.Ride && <PeopleOutlined fontSize="large" />}
          {icon === IconType.Split && <SplitIcon fontSize="large" />}
          {icon === IconType.Reserve && <PersonAdd fontSize="large" />}
          {icon === IconType.Unknown && <Title fontSize="large" />}
          {icon === IconType.Wait && <AccessTime fontSize="large" />}
          {icon === IconType.Walk && <DirectionsWalkIcon fontSize="large" />}
          {icon === IconType.HourglassEmpty && <HourglassEmptyIcon fontSize="large" />}
          {icon === IconType.LocalGasStation && (
            <LocalGasStation fontSize="large" />
          )}
          {icon === IconType.Group && <Group fontSize="large" />}
          {tripIsEu && <img style={classes.euLogo} src="/assets/eu-flag.jpg" alt="EU" />}
        </Box>
        <Box sx={classes.col}>
          <Typography variant="h5">{primary1}</Typography>
          <Typography variant="h5">{primary2}</Typography>
          <Typography variant="subtitle2">{secondary1}</Typography>
          <Typography variant="subtitle2">{secondary2}</Typography>
        </Box>
      </Box>
      {comment! && comment !== '' && (
        <Box px={1} py={1}>
          <InfoCard>
            <InfoCardContent comment={comment} icon={IconType.Info} />
          </InfoCard>
        </Box>
      )}
    </>
  );
};

export const MainCard: FC = ({ children }) => {
  const classes = useMainCardStyles();
  return <Card sx={classes.root}>{children}</Card>;
};
